import React from 'react';
import {Box, Button} from '@material-ui/core';
import PropTypes, {InferProps} from 'prop-types';
import {Link} from 'react-router-dom';
import {RouteItem} from 'commons/types/Types';

function TabPanel(props: InferProps<typeof TabPanel.propTypes>) {
    const {routes, path} = props;

    const tabs = routes.map((item: RouteItem, key: number) => {
        const route = item.layout + (item.exact ? '' : item.path);
        return (
            <Button
                key={key}
                size='small'
                color='primary'
                component={Link}
                to={{pathname: route}}
                disabled={path === route}>
                {item.name}
            </Button>
        );
    });
    return (
        <Box boxSizing={2} pt={4} display='flex' mb={2} justifyContent='center'>
            {tabs}
        </Box>
    );
}

TabPanel.propTypes = {
    routes: PropTypes.any,
    path: PropTypes.string,
};

export default TabPanel;
